// extracted by mini-css-extract-plugin
export var container = "_6a-0";
export var fallback = "_6a-5";
export var fallbackIcon = "_6a-6";
export var hidden = "_6a-2";
export var image = "_6a-3";
export var loaded = "_6a-4";
export var placeholder = "_6a-1";